module.exports = __webpack_public_path__ + "static/media/exuk-web-designer.7b0b5657.jpg";